const BREAKFAST = 1;
const HALF_BOARD = 2;
const FULL_BOARD = 3;
const ALL_INCLUSIVE = 4;
const WITHOUT = 5;

export default {
	BREAKFAST,
	HALF_BOARD,
	FULL_BOARD,
	ALL_INCLUSIVE,
	WITHOUT,
}


// WEBPACK FOOTER //
// ./src/enums/BoardBase.js